import React, { useContext, useState } from 'react';
import { APIContext } from '../contexts/APIContext';
import { ChatbotContext } from '../contexts/ChatbotContext';
import { useMsal } from '@azure/msal-react';
import {
  getConfigIdByDescription,
  getConfigIdByName,
  getUserEnterpriseId,
  trackUserClicks,
  getUserIdFromLocalStorage,
  getValidToken,
} from '../utils';
import { useToast } from './ui/toast/UseToast';

export default function ThumpsDownForm(props: {
  dislikeButtonEnabled: any;
  thumpsDownEnableForm: any;
  responseID: any;
  FeedbackSubmit: any;
}) {
  const { dislikeButtonEnabled, thumpsDownEnableForm, responseID, FeedbackSubmit } = props;
  const {
    userDetails,
    chatSessionId,
    websocketConnectionRef: { current: websocket },
    WBUId,
    AppName,
    accounts,
  } = useContext(APIContext);
  const { genArcPromptAnalyticsUId, setFeedbackSubmit } = useContext(ChatbotContext);
  const [disLikeCustom, setdisLikeCustom] = useState('');
  const [submitEnable, setSubmitEnable] = useState(false);
  const [checkedItems, setCheckedItem] = useState([]);
  // const { accounts } = useMsal();
  // Use toast() to display a toast message
  const { toast } = useToast();

  const handleCheckBoxChange = (value: any) => {
    let item = [];
    setCheckedItem((prevItems: any) => {
      item = prevItems;
      if (prevItems.includes(value)) {
        item = prevItems.filter((item: any) => item !== value);
      } else {
        item = [...prevItems, value];
      }
      if (item.length == 0 || disLikeCustom.length == 0) {
        setSubmitEnable(false);
      } else {
        setSubmitEnable(true);
      }
      return item;
    });
  };

  const customFeedbackHandler = (e: any) => {
    // Filter out invalid '< and >' characters
    const value = e.target.value.replace(/[<>]/g, '');
    setdisLikeCustom(value);
    if (checkedItems.length > 0 && value.length > 0) {
      setSubmitEnable(true);
    }
    if (checkedItems.length == 0 || value.length == 0) {
      setSubmitEnable(false);
    }
  };

  const handleSubmit = async () => {
    const token = await getValidToken();
    const feedBackDetails = checkedItems.map((item) => {
      return {
        ConfigurationUId: getConfigIdByDescription(userDetails.ConfigurationDetails.Feedbacks, item),
      };
    });

    toast({
      status: 'success',
      description: 'Your Feedback sucessfully submitted',
    });

    const request = {
      function: 'save_prompt_feedback',
      userId: getUserIdFromLocalStorage(),
      LoggedInUser: getUserEnterpriseId(accounts),
      ParentConfigurationUId: getConfigIdByName(userDetails.ConfigurationDetails.Feedbacks, 'DisLike'),
      Comments: disLikeCustom,
      FeedBackDetails: feedBackDetails,
      GenArcPromptAnalyticsUId: genArcPromptAnalyticsUId[responseID],
      authorization: `Bearer ${token}`,
    };
    if (websocket && websocket.state === 'Connected') {
      websocket?.send('SendMessage', request);
      thumpsDownEnableForm(false);
      setFeedbackSubmit(true);
      trackUserClicks(
        websocket,
        'DisLike',
        userDetails,
        chatSessionId,
        WBUId,
        AppName,
        accounts,
        token,
        genArcPromptAnalyticsUId[responseID]
      );
    }
  };

  const handleSkip = () => {
    thumpsDownEnableForm(false);
    dislikeButtonEnabled(false);
  };

  return (
    <div className="Prompt-feedback flex flex-col bg-[#FAFAFA] text-gamma-light-grey">
      <div className="border-[1px] border-gamma-bg-purple-bottom">
        <div className="flex pt-2.5">
          <div className="inline-block react-chatbot-kit-chat-bot-avatar-container ">
            <img width="24" height="24" src="/icons/Frame.svg" alt="bot icon"></img>
          </div>
          <div className="inline-block">Let us know what went wrong. Help us improve!</div>
        </div>
        <div className="ml-[3rem]">
          <div className="flex text-base">
            <div className="flex ml-50 mb-[0.125rem] block min-h-[1.5rem]  inline-block w-3/6">
              <input
                type="checkbox"
                value=""
                id="Response was too generic"
                className="accent-[#961FFC] w-4 h-4 mt-1"
                onChange={() => handleCheckBoxChange('Response was too generic')}
              />
              <label className="inline-block pl-3 hover:cursor-pointer  text-left" htmlFor="Response was too generic">
                Response was too generic
              </label>
            </div>
            <div className="flex mb-[0.125rem] block min-h-[1.5rem] pl-[1.5rem] inline-block">
              <input
                type="checkbox"
                value=""
                className="accent-[#961FFC] w-4 h-4 text-black mt-1"
                id="Response was not accurate"
                onChange={() => handleCheckBoxChange('Response was not accurate')}
              />
              <label className="inline-block pl-3 hover:cursor-pointer  text-left" htmlFor="Response was not accurate">
                Response was not accurate
              </label>
            </div>
          </div>
          <div className="flex text-base">
            <div className="flex mb-[0.125rem] block min-h-[1.5rem]  inline-block w-3/6">
              <input
                type="checkbox"
                className="accent-[#961FFC] w-4 h-4 mt-1"
                value=""
                id="Response was not relevant to the question"
                onChange={() => handleCheckBoxChange('Response was not relevant to the question')}
              />
              <label
                className="inline-block pl-3 hover:cursor-pointer  text-left"
                htmlFor="Response was not relevant to the question"
              >
                Response was not relevant to the question
              </label>
            </div>
            <div className="flex mb-[0.125rem] block min-h-[1.5rem] pl-[1.5rem] inline-block">
              <input
                type="checkbox"
                value=""
                className="accent-[#961FFC] w-4 h-4 mt-1"
                id="Response was not provided"
                onChange={() => handleCheckBoxChange('Response was not provided')}
              />
              <label className="inline-block pl-3 hover:cursor-pointer  text-left" htmlFor="Response was not provided">
                Response was not provided
              </label>
            </div>
          </div>
          <div className="flex text-base">
            <div className="flex mb-[0.125rem] block min-h-[1.5rem]  inline-block w-3/6">
              <input
                type="checkbox"
                className="accent-[#961FFC] w-4 h-4 mt-1"
                value=""
                id="Response was not in the correct structure"
                onChange={() => handleCheckBoxChange('Response was not in the correct structure')}
              />
              <label
                className="inline-block pl-3 hover:cursor-pointer  text-left"
                htmlFor="Response was not in the correct structure"
              >
                Response was not in the correct structure (style, formatting, grammar, etc.)
              </label>
            </div>
            <div className="flex mb-[0.125rem] block min-h-[1.5rem] pl-[1.5rem] inline-block">
              <input
                type="checkbox"
                value=""
                className="accent-[#961FFC] w-4 h-4 mt-1"
                id="Other"
                onChange={() => handleCheckBoxChange('Other')}
              />
              <label className="inline-block pl-3 hover:cursor-pointer  text-left" htmlFor="Other">
                Others (Write your response)
              </label>
            </div>
          </div>
          <div className="pt-3">
            <img className="py-1" width="4" height="4" src="/icons/mandatory.svg" alt="bot icon" />
            <textarea
              className="Scrollbar block mb-2 text-base font-normal text-gray-900 w-11/12 height-10 border-[#000] border-[1px] outline-none resize-none pt-2 pl-3"
              rows={4}
              cols={80}
              maxLength={500}
              placeholder="Write your feedback here..."
              value={disLikeCustom}
              onChange={(e) => {
                customFeedbackHandler(e);
              }}
            ></textarea>
            <label className="float-right mr-10 mt-1 mb-4 text-left text-base text-[#737373]">
              Max input 500 Characters
            </label>
          </div>
        </div>
      </div>
      <div className="float-right pt-9 bg-[#F5F5F5]">
        {submitEnable ? (
          <button
            className="rounded-sm border border-[#000] bg-[#000000] px-4 py-2 hover:bg-[#A100FF] hover:border-[#A100FF] float-right text-white"
            onClick={() => {
              handleSubmit();
              FeedbackSubmit(false);
            }}
          >
            {' '}
            Submit Feedback
          </button>
        ) : null}
        {submitEnable ? null : (
          <button className="rounded-sm border border-[#FAFAFA] bg-[#cccccc] px-4 py-2  float-right text-white cursor-default">
            {' '}
            Submit Feedback
          </button>
        )}
        <button
          className="rounded-sm border border-[#000] bg-[#FFFFFF] px-4 py-2 mr-4 hover:bg-opacity-70 float-right"
          onClick={handleSkip}
        >
          Cancel
        </button>
      </div>
    </div>
  );
}
